import React from "react";
import { Modal } from "react-bootstrap";
import useUserAgreement from "hooks/useUserAgreement";
import { useState } from "react";
import { Checkbox } from "components/Form/Checkbox";
import UserAgreementText from "./UserAgreementText";

export default function UserAgreement({ show, onHide, identityNumber }) {
  const [loading, setLoading] = useState(false);
  const [isChecked, setChecked] = useState(false);
  const { confirmUserAgreement } = useUserAgreement({
    onConfirmSuccess: onHide
  });

  const onSubmit = () => {
    setLoading(true);
    confirmUserAgreement(identityNumber);
  };

  return (
    <Modal show={show} size="xl">
      <Modal.Header>
        <span className="h5">KVKK Aydınlatma Metni</span>
      </Modal.Header>
      <Modal.Body>
        <UserAgreementText />
      </Modal.Body>
      <Modal.Footer className="d-flex align-items-center">
        <div className="d-flex mr-4">
          <Checkbox
            isSelected={isChecked}
            onChange={() => {
              setChecked(!isChecked);
            }}
          />
          <label className="ml-2 lms-text-elipsis mt-1">Okudum, Anladım</label>
        </div>
        <button className="btn btn-primary" onClick={onSubmit} disabled={loading || !isChecked}>
          {loading && <span className="spinner spinner-white mr-10"></span>}
          Kabul Et
        </button>
      </Modal.Footer>
    </Modal>
  );
}
